import React from "react";
import { TermsRow, NextIsAgainFree, NextIsPaid, NextIsReadOnly, NextIsCancelled, NotImplementedSubscription } from "../Components/CommonPanelContent";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const DetailsTable = () => (
  <table className="s1_table clean rowspace-small margin-bottom-large">
    <tbody>
      <tr>
        <td>{RESX.Subscription.resxSubscription}:</td>
        <td>{RESX.Subscription.ThisAccountIsForNonCommercialPurposes}</td>
      </tr>
      <TermsRow />
    </tbody>
  </table>);

const FreeSubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <>
        <NextIsAgainFree />
      </>;
    case "paid":
      return <>
        <DetailsTable />
        <NextIsPaid {...props} />
      </>;
    case "readOnly":
      return <>
        <DetailsTable />
        <NextIsReadOnly {...props} />
      </>;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <>
        <DetailsTable />
        <NextIsCancelled {...props} tip="readOnly" />
      </>;

    default:
      return <NotImplementedSubscription />;
  }
};

export default FreeSubscription;
